var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "product-info"
  }, [_c('div', {
    staticClass: "content info-content"
  }, [_c('v-row', {
    staticClass: "pa-5 ma-0"
  }, [_c('v-col', {
    staticClass: "flex-grow-0 pa-0 ma-0"
  }, [_c('div', {
    staticClass: "image-upload-ctn pr-5"
  }, [_vm.productImage ? _c('div', {
    staticClass: "d-flex flex-row align-center mb-3 img-ctn"
  }, [_c('img', {
    attrs: {
      "src": _vm.productImage
    }
  }), _vm.productForm.image ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "delete-btn",
          attrs: {
            "icon": ""
          }
        }, 'v-btn', attrs, false), Object.assign({}, on, {
          click: _vm.removeProductPicture
        })), [_c('v-icon', {
          attrs: {
            "color": "red"
          }
        }, [_vm._v("mdi-delete-outline")])], 1)];
      }
    }], null, false, 3047601518)
  }, [_c('span', {
    staticClass: "black--text body-2"
  }, [_vm._v(_vm._s(_vm.$t('delete_image')))])]) : _vm._e()], 1) : _vm._e(), _c('ImageCropper', {
    attrs: {
      "input-key": "logo",
      "gallery-only": true,
      "show-select-dialog": true
    },
    on: {
      "image-selected": _vm.onImageSelect
    }
  })], 1)]), _c('v-col', {
    staticClass: "py-0 product-form pl-0",
    attrs: {
      "cols": _vm.$vuetify.breakpoint.smAndDown ? 12 : 6
    }
  }, [_c('v-form', {
    ref: "product-form",
    model: {
      value: _vm.valid,
      callback: function ($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c('v-row', {
    staticClass: "my-1 mx-0"
  }, [_c('v-col', {
    staticClass: "pt-0 px-0",
    attrs: {
      "cols": 12
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "small": "",
      "name": "name",
      "persistent-hint": "",
      "label": _vm.$t('product_name'),
      "hint": _vm.$t('product_name_hint'),
      "rules": _vm.rules.name,
      "error-messages": _vm.errorMessages.name,
      "required": ""
    },
    on: {
      "focus": function ($event) {
        return _vm.clearErrors('name');
      }
    },
    model: {
      value: _vm.productForm.name,
      callback: function ($$v) {
        _vm.$set(_vm.productForm, "name", $$v);
      },
      expression: "productForm.name"
    }
  })], 1), _c('v-col', {
    staticClass: "pt-0 px-0",
    attrs: {
      "cols": 12
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "small": "",
      "name": "sku",
      "persistent-hint": "",
      "label": _vm.$t('product_internal_name'),
      "hint": _vm.$t('product_sku_hint'),
      "rules": _vm.rules.sku,
      "error-messages": _vm.errorMessages.sku,
      "required": ""
    },
    on: {
      "focus": function ($event) {
        return _vm.clearErrors('sku');
      }
    },
    model: {
      value: _vm.productForm.sku,
      callback: function ($$v) {
        _vm.$set(_vm.productForm, "sku", $$v);
      },
      expression: "productForm.sku"
    }
  })], 1), _c('v-col', {
    staticClass: "pt-0 px-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "dense": "",
      "small": "",
      "counter": "500",
      "label": _vm.$t('description'),
      "persistent-hint": "",
      "hint": _vm.$t('description_hint'),
      "rules": _vm.rules.description
    },
    model: {
      value: _vm.productForm.description,
      callback: function ($$v) {
        _vm.$set(_vm.productForm, "description", $$v);
      },
      expression: "productForm.description"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "actions-ctn"
  }, [_c('v-btn', {
    staticClass: "save-btn px-6",
    attrs: {
      "loading": _vm.loading,
      "color": "primary",
      "raised": ""
    },
    on: {
      "click": function ($event) {
        return _vm.save();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))])], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }